import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { TagsCreate } from 'components/Settings/Components/Tags/components/tagsCreate';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const TagsCreatePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.tagsNew.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.tags.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <TagsCreate />
            </MainContent>
        </PageContainer>
    );
};
